import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate, useParams } from 'react-router';
import { useSnackBar } from '../components/ToastProvider';
import { queryClient } from '../react-query/queryClient';
import businessUnitApi from '../services/businessUnit';
import { BusinessUnit } from '../modules/Users/Accounts/businessUnit-utils';

interface ApiError {
  status: number;
  message: string;
}

export function useGetBusinessUnitQuery() {
  return useQuery<BusinessUnit[]>(['businessUnit'], () => businessUnitApi.getBusinessUnit(), {
    onError(err) {
      console.log(err);
    },
  });
}

// export function useGetRoleById() {
//   const { id } = useParams<{ id: string }>();
//   return useQuery([`roles-${id}`, id], () => businessUnitApi.getBusinessUnitById(id!));
// }




